import { datetimeFormatter } from 'utils/datetime';

export const solutionsTableColumns = [
  { field: 'type', label: 'Type' },
  { field: 'display_name', label: 'Name' },
  { field: 'lastmoddate', label: 'Updated Date', formatter: datetimeFormatter },
  { field: 'createddate', label: 'Created Date', formatter: datetimeFormatter },
];
